// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CartProvider } from './CartContext';
import { CurrencyProvider } from './CurrencyContext'; // ✅ NEW
import reportWebVitals from './reportWebVitals';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CurrencyProvider> {/* ✅ NEW: Wrap with CurrencyProvider */}
      <CartProvider>
        <App />
      </CartProvider>
    </CurrencyProvider>
  </React.StrictMode>
);

reportWebVitals();
